export default "__VITE_ASSET__66VmJB_B__"